var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"virtualBoothHolder",staticClass:"virtual-booth-holder"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[[(_vm.site_config.use_intro_form && _vm.show_booth_form)?_c('BoothForm',{key:"3"}):_vm._e()]],2),_vm._v(" "),_c('UnityContainer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6133838","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage.vue
// module id = null
// module chunks = 